import React from 'react';
import { Avatar, Space } from 'components/barbr';

import { isEmpty } from '_dash';
import { openMapLink } from 'utils';
import { ReactComponent as LocationSvg } from 'assets/location.svg';

import BMap from 'components/barbr/Map';
import { UserIcon } from 'components/Icon';

const WebProfileLocation = React.memo(({ address, detail }) => {
  const { coordinates = {} } = address;

  return (
    <div className='mb-24'>
      <p className='text-3xl semi-bold mb-16'>Location</p>
      <If condition={!isEmpty(coordinates)}>
        <div className='map-wrapper'>
          <BMap coordinates={coordinates} height='24rem' iconSize={[36, 40]} />
          <Space className='info'>
            <Space size={16}>
              <Choose>
                <When condition={detail.image}>
                  <Avatar src={detail.image} size={48} shape='circle' />
                </When>
                <Otherwise>
                  <UserIcon size={48} />
                </Otherwise>
              </Choose>
              <div>
                <p className='text-2xl semi-bold name'>{detail.display_name}</p>
                <p className='text-xl'>{address.display_name || address.formatted_name}</p>
              </div>
            </Space>
            <div className='mark-icon' onClick={() => openMapLink(address.formatted_name)}>
              <LocationSvg />
            </div>
          </Space>
        </div>
      </If>
    </div>
  );
});

export default WebProfileLocation;
